import { BorderRadius } from '../../../enums/borderRadius'

export const getFullScreenSizeModalStyles = (): string => {
  return `
    height: 100%;
    max-height: 100%;
    margin: 0;
    border-radius: ${BorderRadius.R0};
    box-shadow: none;
  `
}
